var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37836e-06 89.9901V294.99C-0.00131202 299.756 0.936016 304.475 2.75855 308.878C4.58108 313.282 7.25316 317.283 10.6221 320.654C13.991 324.025 17.9907 326.699 22.3931 328.524C26.7955 330.349 31.5144 331.289 36.28 331.29H228.79C233.557 331.291 238.278 330.353 242.683 328.53C247.088 326.706 251.09 324.032 254.461 320.661C257.832 317.29 260.506 313.288 262.329 308.883C264.153 304.478 265.091 299.757 265.09 294.99V36.3C265.091 31.5327 264.153 26.8118 262.329 22.4071C260.506 18.0024 257.832 14.0002 254.461 10.6292C251.09 7.25812 247.088 4.58428 242.683 2.7605C238.278 0.936719 233.557 -0.00131249 228.79 1.3783e-06H90.01L18.8398 71.15L1.37836e-06 89.9901Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901L18.8398 71.15L90.01 1.3783e-06H228.79C233.557 -0.00131249 238.278 0.936719 242.683 2.7605C247.088 4.58428 251.09 7.25812 254.461 10.6292C257.832 14.0002 260.506 18.0024 262.329 22.4071C264.153 26.8118 265.091 31.5327 265.09 36.3V120.66H0V89.9901Z",
    fill: "#777E8A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 89.99L44.4299 99.7999C53.8584 101.747 63.6739 99.868 71.7173 94.5776C79.7607 89.2872 85.3731 81.0184 87.3198 71.59L89.1799 61.3999C88.5906 64.2106 87.6568 66.9378 86.3999 69.5199C83.4265 75.6558 78.785 80.8303 73.0071 84.4506C67.2291 88.0708 60.5484 89.9906 53.73 89.99H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 89.9901H53.6899C60.5084 89.9908 67.1891 88.071 72.967 84.4507C78.745 80.8304 83.3864 75.656 86.3599 69.52C88.7277 64.5783 89.9612 59.1698 89.97 53.6901V0L18.8 71.15L0 89.9901Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 175H54V186H67V175Z",
    fill: "#777E8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 175H75V186H88V175Z",
    fill: "#777E8A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109 175H96V186H109V175Z",
    fill: "#777E8A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 206H54V217H67V206Z",
    fill: "#777E8A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88 206H75V217H88V206Z",
    fill: "#777E8A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109 206H96V217H109V206Z",
    fill: "#777E8A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67 238H54V249H67V238Z",
    fill: "#777E8A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88 238H75V249H88V238Z",
    fill: "#777E8A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109 238H96V249H109V238Z",
    fill: "#777E8A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67 269H54V280H67V269Z",
    fill: "#777E8A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88 269H75V280H88V269Z",
    fill: "#777E8A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M109 269H96V280H109V269Z",
    fill: "#777E8A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161 269H148V280H161V269Z",
    fill: "#777E8A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M182 269H169V280H182V269Z",
    fill: "#777E8A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203 269H190V280H203V269Z",
    fill: "#777E8A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.007 81V83.917H118.057V81H143.007ZM168.099 81V83.917H143.148V81H168.099ZM193.19 81V83.917H168.24V81H193.19ZM218.282 81V83.917H193.332V81H218.282Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.f03b822b4121ae40efbd6288cf167845.svg";
export { ForwardRef as ReactComponent };